const API_KEY = process.env.REACT_APP_AWS_FRIENDZ_API_KEY;
const REGION = process.env.REACT_APP_AWS_REGION;
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getCitySuggestions = async (query) => {
  try {
    const url = `${BASE_URL}/autocomplete`;
    const requestBody = {
      QueryText: query,
      MaxResults: 10,
      Filter: {
        IncludeCountries: ["USA"]
      }
    };

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': API_KEY
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`API response was not OK: ${errorText}`);
    }

    const data = await response.json();
    // Filter for Locality types and extract city/state from Label
    // Label format: "Cincinnati, OH, United States"
    return data.ResultItems
      .filter((item) => item.PlaceType === 'Locality')
      .map((item) => {
        const labelParts = item.Address.Label.split(', ');
        const city = labelParts[0];
        const state = labelParts[1];
        return {
          city,
          state,
          label: `${city}, ${state}`
        };
      })
      .filter(item => item.city && item.state)
      .slice(0, 5);

  } catch (error) {
    console.error('Error fetching city suggestions:', error);
    return [];
  }
};

export const getPlaceSuggestions = async (query) => {
  try {
    const url = `${BASE_URL}/autocomplete`;
    const requestBody = {
      QueryText: query,
      MaxResults: 5,
      "Filter": { 
        "IncludeCountries": [ "USA" ]
      },
      AdditionalFeatures: [
       "Core"
     ]
    };

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': API_KEY
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`API response was not OK: ${errorText}`);
    }

    const data = await response.json();
    return data.ResultItems.map((item) => item.Address.Label);
    
  } catch (error) {
    console.error('Error fetching place suggestions:', error);
    throw error;
  }
};
